export default __webpack_public_path__ + "static/media/check.c87fc0ac.svg";